export default __webpack_public_path__ + "static/media/gallery_01.b3e72d2a.jpg";